import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=4d05ca76&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=4d05ca76&prod&lang=scss&scoped=true"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=4d05ca76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d05ca76",
  null
  
)

export default component.exports